interface ChatHeaderProps {
  isConnected: boolean
  conversationalMode: boolean
  onToggleMode: (checked: boolean) => void
  onNewConversation: () => void
}

export default function ChatHeader({ 
  isConnected, 
  conversationalMode, 
  onToggleMode, 
  onNewConversation 
}: ChatHeaderProps) {
  return (
    <div className="border-b px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <h2 className="text-lg font-semibold">Tapestry Chat</h2>
          <div className={`w-2 h-2 rounded-full ${isConnected ? 'bg-green-500' : 'bg-red-500'}`} />
        </div>
        
        <div className="flex items-center space-x-4">
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={conversationalMode}
              onChange={(e) => onToggleMode(e.target.checked)}
              className="w-4 h-4 text-blue-500 rounded focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700">Conversational Mode</span>
          </label>
          
          <button
            onClick={onNewConversation}
            className="px-3 py-1 text-sm bg-[#FF6600] text-white rounded hover:bg-[#CC5200] transition-colors"
          >
            New Chat
          </button>
        </div>
      </div>
    </div>
  )
}